export const GET_ORDER_LIST_SUCCESS = "GET_ORDER_LIST_SUCCESS";
export const UPDATE_BASKET = "UPDATE_BASKET";
export const UPDATE_PUBLIC_BUYER = "UPDATE_PUBLIC_BUYER";
export const UPDATE_ORDER_OPERATION_DATA = "UPDATE_ORDER_OPERATION_DATA";